import { useQueryCore } from "@/hooks/useQueryCore";
import { useDistrictGuard } from "@/hooks/useDistrictGuard";
import { getFamiliesWithLastVisit } from "@/lib/api";

const sortFamilies = (data) =>
  (data || []).slice().sort((a, b) => {
    return (b.days_since ?? 999) - (a.days_since ?? 999);
  });

export function useFamiliesRanking() {
  const { districtId, coordinatorChurchId } = useDistrictGuard();

  const query = useQueryCore({
    key: ["families-ranking", districtId, coordinatorChurchId],
    enabled: !!districtId,
    queryFn: () => getFamiliesWithLastVisit(districtId, coordinatorChurchId),
    sortFn: sortFamilies,
    cacheKey: districtId
      ? coordinatorChurchId
        ? `families_rank_${districtId}_${coordinatorChurchId}`
        : `families_rank_${districtId}`
      : null,
  });

  return {
    families: query.data || [],
    loading: query.loading,
    error: query.error,
    refetch: query.refetch,
  };
}
